import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

import '../src/assets/css/style2.css';
import '../src/assets/css/lineicons.css';
import '../src/assets/css/datepicker.min.css';
import '../src/assets/css/fancybox.min.css';
import '../src/assets/css/swiper2.min.css';
import '../src/assets/css/bootstrap.min.css';
import '../src/assets/css/style.css';
import '../src/assets/css/globalStyles.css';




import Home from './pages/Home';
import Offer from './pages/Offer';
import Accommodation from './pages/Accommodation';
import Loftsuit from './pages/Loftsuit';
import Master from './pages/Master';
import Double from './pages/Double';
import Twin from './pages/Twin';
import Dining from './pages/Dining';
import Contactus from './pages/Contactus';
import Kent from './pages/Kent';
import Gallery from './pages/Gallery';


function App() {
  useEffect(() => {
    // Create custom cursor element
    const cursor = document.createElement('div');
    cursor.className = 'custom-cursor';
    document.body.appendChild(cursor);

    let mouseX = 0;
    let mouseY = 0;
    let cursorX = 0;
    let cursorY = 0;
    const delay = 0.1; // Delay factor (lower = more delay)

    // Mouse move handler - just store position
    const handleMouseMove = (e) => {
      mouseX = e.clientX;
      mouseY = e.clientY;
    };

    // Animate cursor with delay
    const animateCursor = () => {
      cursorX += (mouseX - cursorX) * delay;
      cursorY += (mouseY - cursorY) * delay;
      
      cursor.style.left = cursorX + 'px';
      cursor.style.top = cursorY + 'px';
      
      requestAnimationFrame(animateCursor);
    };

    // Mouse down handler
    const handleMouseDown = () => {
      cursor.classList.add('clicking');
    };

    // Mouse up handler
    const handleMouseUp = () => {
      cursor.classList.remove('clicking');
    };

    // Add event listeners
    document.addEventListener('mousemove', handleMouseMove);
    document.addEventListener('mousedown', handleMouseDown);
    document.addEventListener('mouseup', handleMouseUp);
    
    // Start animation
    animateCursor();

    // Cleanup
    return () => {
      document.removeEventListener('mousemove', handleMouseMove);
      document.removeEventListener('mousedown', handleMouseDown);
      document.removeEventListener('mouseup', handleMouseUp);
      if (cursor && cursor.parentNode) {
        cursor.parentNode.removeChild(cursor);
      }
    };
  }, []);

  return (
    <Router>
      <div>
        <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/kent/offers" element={<Offer />} />
        <Route path="/kent/accommodation" element={<Accommodation />} />
        <Route path="/kent/room-loftsuite" element={<Loftsuit/>} />
        <Route path="/kent/room-masterroom" element={<Master/>} />
        <Route path="/kent/room-doubleroom" element={<Double/>} />
        <Route path="/kent/room-twinroom" element={<Twin/>} />
        <Route path="/kent/dining" element={<Dining/>} />
        <Route path="/kent/contactus" element={<Contactus/>} />
        <Route path="/kent/theKentCottage" element={<Kent/>} />
        <Route path="/kent/gallery" element={<Gallery/>} />

        </Routes>
      </div>
    </Router>
  );
}

export default App;